import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import { COLOR_PRIMARY_DARK, COLOR_BLUE_BLACK_LIGHT, BACKGROUND_COLOR } from 'src/utils/const';

const UnAuthorizedMessage = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h3"
        sx={{ color: COLOR_PRIMARY_DARK, fontWeight: 'bold', marginBottom: '20px' }}
      >
        Unauthorized Access!
      </Typography>
      <Typography variant="body1" sx={{ color: COLOR_BLUE_BLACK_LIGHT, fontSize: '24px' }}>
        ←{' '}
        <Link href="/" color="inherit">
          back to homepage
        </Link>
      </Typography>
    </div>
  );
};

export default UnAuthorizedMessage;
